import VatInfoText from './VatInfoText';

export default VatInfoText;
